import { pathMaker } from "../../../utils/helperFunction";
import { CloseIcon } from "../../kits/Icons";
export default function PreviewImage({
  onChangeFunc,
  fileValue,
  show = false,
}) {
  return (
    <div
      className="border rounded mt-2 position-relative mx-auto"
      style={{ width: 150 }}
    >
      {show ? (
        <img
          className="mx-auto"
          style={{ height: "100px", width: "80%", objectFit: "contain" }}
          src={pathMaker(fileValue)}
        />
      ) : (
        <img
          className="mx-auto"
          style={{ height: "100px", width: "80%", objectFit: "contain" }}
          src={URL.createObjectURL(fileValue)}
        />
      )}

      {!show && (
        <div
          className="position-absolute  bg-danger rounded-pill"
          style={{ top: -8, right: -8, cursor: "pointer" }}
          onClick={onChangeFunc}
        >
          <CloseIcon color="white" style={{ width: 20, height: 20 }} />
        </div>
      )}
    </div>
  );
}
